import UsaFlag from '@/assets/images/country-flags/012-united-states.png'
import GermanyFlag from '@/assets/images/country-flags/013-germany.png'
import JanpanFlag from '@/assets/images/country-flags/014-japan.png'
import VietnamFlag from '@/assets/images/country-flags/015-vietnam.png'
import IndiaFlag from '@/assets/images/country-flags/016-india.png'
import BrazilFlag from '@/assets/images/country-flags/017-brazil.png'
import SouthAfricaFlag from '@/assets/images/country-flags/018-south-africa.png'
import UnitedArabFlag from '@/assets/images/country-flags/019-united-arab-emirates.png'
import LogoDev from '@/assets/images/logo-dev.webp'
import Logo from '@/assets/images/logo.webp'

export const DEFAULT_LOGO = import.meta.env.VITE_ENV === 'PROD' ? Logo : LogoDev
export const REGIONS = [
  {
    value: 'singapore',
    image: VietnamFlag,
  },
  { value: 'ohio', image: UsaFlag },
  { value: 'frankfurt', image: GermanyFlag },
  { value: 'tokyo', image: JanpanFlag },
  { value: 'mumbai', image: IndiaFlag },
  { value: 'saopaulo', image: BrazilFlag },
  { value: 'uae', image: UnitedArabFlag },
  { value: 'capetown', image: SouthAfricaFlag },
]
